<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14thdGy/CoverDesign.jpg?1684306108641" alt="This image is the cover for the book Unusual Attention"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Unusual Attention
      </h1>
      <p class="bookDescription body article font2">
        <p>Until recently, Adam Brookhart has led what he considers a relatively uneventful life. His biggest problem is that he can’t let his guard down and allow himself to get close to anyone, emotionally or physically—until he meets Shane Farmer.</p> <p>Shane lives in a small town many miles from Adam and is his complete opposite. In fact, he’s just about the last person Adam can imagine himself in a relationship with. But Adam is drawn to the man, and neither distance nor their differences can keep him away.</p> <p>Late one night, while driving home from Shane’s house, something very strange happens. Adam loses two hours of time and has no idea how or why. But as he digs for clues, the answers he finds are totally crazy… and the man he is falling in love with might be crazy as well.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        B.G. Thomas
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4fb4912c